import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import Switches from "vue-switches";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import ClientDetailsMixin from "./ClientDetailsMixin";
import StrictDateMixin from "@/router/views/StrictDateMixin";
import Loader from "../../../components/widgets/loader.vue";
import ClientModule from "@/store/modules/client.module";
import EcGrid from "@/components/widgets/EcGrid.vue";
import { clientRiskColorName } from "@/store/models/client/clientRisk";
import SectionLoader from "../../../components/widgets/SectionLoader.vue";
import clientModule from "@/store/modules/client.module";
import { toaster } from "@/utilities/toaster";
import DeleteComponent from "@/components/deleteComponent.vue";
import { ClientDeactivationReasonModel } from "@/store/models/client/clientDeactivationReasonDTO";
/**
 * Client Listing Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo", "beforeRouteEnter"]);
let ClientsListing = /** @class */ (() => {
    let ClientsListing = class ClientsListing extends Mixins(ClientDetailsMixin, StrictDateMixin) {
        constructor() {
            // DATA
            super(...arguments);
            this.isPageLoading = true;
            this.showDeleteModal = false;
            this.deactivateReason = "";
            this.deactivationDate = null;
            // Start Date of the client being deactivated - the earliest Deactivation Date allowed
            this.deactivatingClientStartDate = null;
            // Off: active clients only. On: inactive clients only. Sent as the isActive filter.
            this.showInactive = false;
            this.title = "Clients";
            this.initialSortBy = {
                field: "name",
                type: "asc",
            };
            this.isPageDirty = false;
            this.isPageChanged = false;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "PMO",
                    href: "#",
                },
                {
                    text: "Clients",
                    active: true,
                },
            ];
            // Grid
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.columns = [
                {
                    field: "name",
                    label: "Client Name",
                    tdClass: "client-name",
                    thClass: "client-name-header",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Client Name",
                    },
                },
                {
                    field: "primaryContacts",
                    label: "Primary Contacts",
                    tdClass: "client-contacts",
                    thClass: "client-contacts-header",
                    sortable: false,
                },
                // Appraisal reviewers and leave approvers are set per team member in Team Correspondence
                {
                    field: "appraisalReviewers",
                    label: "Appraisal Reviewers",
                    tdClass: "client-contacts",
                    thClass: "client-contacts-header",
                    sortable: false,
                },
                {
                    field: "primaryLeaveApprovers",
                    label: "Primary Leave Approvers",
                    tdClass: "client-contacts",
                    thClass: "client-contacts-header",
                    sortable: false,
                },
                {
                    field: "secondaryLeaveApprovers",
                    label: "Secondary Leave Approvers",
                    tdClass: "client-contacts",
                    thClass: "client-contacts-header",
                    sortable: false,
                },
                // {
                // 	field: "latestRiskColor",
                // 	label: "Risk",
                // 	tdClass: "client-risk",
                // 	thClass: "client-risk-header",
                // 	sortable: false,
                // 	filterOptions: {
                // 		enabled: true,
                // 		placeholder: "All",
                // 		// Risk level names, filled once the levels are loaded
                // 		filterDropdownItems: [],
                // 		styleClass: "client-risk-filter",
                // 	},
                // },
                // {
                // 	field: "isActive",
                // 	label: "Status",
                // 	thClass: "client-status-header",
                // 	tdClass: "client-status",
                // 	sortable: true,
                // },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "text-center client-actions-header",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "name",
                    type: "asc",
                },
                page: 1,
                pageSize: 10,
            };
            this.totalCount = 0;
            // Contact columns (Primary Contacts, leave approvers, appraisal reviewers): photo stack like the Projects listing's Members - the first few, then "+N"
            this.contactFields = ["primaryContacts", "primaryLeaveApprovers", "secondaryLeaveApprovers", "appraisalReviewers"];
            this.maxStackedContacts = 5;
        }
        //Methods
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        // Active clients wear their latest risk as a chip around the name (dashed when none is recorded).
        // The inactive view keeps a plain name.
        showNameChip() {
            return !this.showInactive;
        }
        // health-risk-red / -orange / -green; a level without a colour of its own keeps the plain grey chip
        nameRiskClass(row) {
            return row.latestRiskColor ? `health-risk-${clientRiskColorName(row.latestRiskColor)}` : "health-risk-none";
        }
        // Level name, then the description when one was recorded
        nameRiskTitle(row) {
            if (!row.latestRiskColor) {
                return "No risk recorded";
            }
            const label = this.riskColorShortLabel(row.latestRiskColor);
            const description = this.insightText(row.latestRiskDescription);
            const hasDescription = description !== "No description recorded.";
            if (label && hasDescription) {
                return `Risk: ${label} — ${description}`;
            }
            return label ? `Risk: ${label}` : description;
        }
        isContactField(field) {
            return this.contactFields.indexOf(field) > -1;
        }
        stackedContacts(contacts) {
            return (contacts || []).slice(0, this.maxStackedContacts);
        }
        hiddenContacts(contacts) {
            return (contacts || []).slice(this.maxStackedContacts);
        }
        // The "+N" badge lists the names it stands for
        hiddenContactNames(contacts) {
            return this.hiddenContacts(contacts)
                .map((contact) => contact.name)
                .join(", ");
        }
        deleteClient() {
            this.isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            clientModule.DeleteClientById(this.clientId).then((response) => {
                if (response) {
                    if (this.isPageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                    toaster.ShowSuccess("Client was deleted successfully.");
                    this.loadItems();
                }
            });
            this.showDeleteModal = false;
        }
        openDeleteModal(clientId) {
            this.isPageChanged = false;
            this.clientId = clientId;
            this.showDeleteModal = true;
            this.isPageLoading = false;
        }
        openDeactivateModal(row) {
            this.clientId = row.id;
            this.deactivatingClientStartDate = row.startDate || null;
            // Deactivation Date defaults to today (left empty if the client only starts later)
            const today = this.toCalendarDay(new Date());
            this.deactivationDate = this.isBeforeClientStartDate(today, this.deactivatingClientStartDate) ? null : today;
            this.clearDateErrors();
            this.$bvModal.show("reason-for-deactivation");
            this.isPageLoading = false;
        }
        // Deactivation Date picker: no future days, nothing before the client's Start Date
        disableDeactivationDate(date) {
            return date > this.toCalendarDay(new Date()) || this.isBeforeClientStartDate(date, this.deactivatingClientStartDate);
        }
        deActivateClient() {
            this.validate("clientDeactivationObserver").then((res) => {
                if (res && !this.hasDateErrors) {
                    const deactivation = new ClientDeactivationReasonModel();
                    deactivation.clientId = this.clientId;
                    deactivation.deactivatedReason = this.deactivateReason;
                    deactivation.deactivationDateAsString = this.formatClientDate(this.deactivationDate);
                    ClientModule.DeactivateClient(deactivation).then((res) => {
                        toaster.ShowSuccess("Client was deactivated successfully.");
                        this.loadItems();
                    });
                    this.$bvModal.hide("reason-for-deactivation");
                    this.deactivateReason = "";
                    this.deactivationDate = null;
                }
            });
        }
        cancelDeactivate() {
            this.$bvModal.hide("reason-for-deactivation");
            this.deactivateReason = "";
            this.deactivationDate = null;
        }
        cancelDelete() {
            this.isPageChanged = false;
            this.showDeleteModal = false;
        }
        onSortChange(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            if (!this.isPageDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: this.columnFilters,
            };
            ClientModule.AssignSearchParams(searchData);
            ClientModule.GetClients(searchData).then((response) => {
                this.totalCount = response.totalCount;
                this.isGridLoading = false;
                this.isPageDirty = false;
            });
        }
        // The label toggles the same switch as the control, then reloads. The switch's own input only reloads.
        toggleShowInactive() {
            this.showInactive = !this.showInactive;
            this.onShowInactiveChange();
        }
        // Switches between the active and the inactive clients; back to the first page
        onShowInactiveChange() {
            this.initialPage = 1;
            this.updateParams({ page: 1 });
            this.loadItems();
        }
        // The Show Inactive toggle is a view switch, not a column filter, so Clear Filter leaves it as is
        clearFilter() {
            this.serverParams.columnFilters = {};
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name != "ClientDetails") {
                ClientModule.ClearSearchParams();
            }
            next();
        }
        onRowClick(params) {
            this.$router.push({ name: "ClientDetails", params: { clientId: params.row.id } });
        }
        // The Updates page with this client selected
        updatesLink(row) {
            return { name: "Updates", query: { clientId: row.id.toString() } };
        }
        initialize() {
            var value = ClientModule.searchParams;
            if (value != null) {
                this.isPageDirty = true;
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                value.columnFilters.forEach((item) => {
                    if (item.name === "isActive") {
                        this.showInactive = item.value === "Inactive";
                        return;
                    }
                    // The Risk column is gone; a leftover filter would hide rows with no control to clear it
                    if (item.name === "latestRiskColor") {
                        return;
                    }
                    this.serverParams.columnFilters[item.name] = item.value;
                });
                // A sort on a column that's no longer listed (SS / SOW date) falls back to Client Name
                if (value.sort && this.columns.some((x) => x.field === value.sort.field)) {
                    this.initialSortBy = value.sort;
                }
            }
        }
        assignColumnFilters() {
            var ecgrid = this.$refs.ecgrid;
            var gridColumns = ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters;
            if (this.gridParams && this.gridParams.columnFilters.length > 0) {
                this.isPageDirty = true;
                this.gridParams.columnFilters
                    .filter((item) => item.name !== "isActive" && item.name !== "latestRiskColor")
                    .forEach((item) => {
                    gridColumns[item.name] = item.value;
                });
            }
        }
        get gridParams() {
            return ClientModule.searchParams;
        }
        // The Show Inactive toggle's isActive filter is always sent, so it doesn't count as an applied filter
        get isAnyFilterApplied() {
            return this.columnFilters.some((x) => x.name !== "isActive" && x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                if (key === "isActive") {
                    return;
                }
                filters.push({
                    name: key,
                    value: value,
                });
            });
            filters.push({
                name: "isActive",
                value: this.showInactive ? "Inactive" : "Active",
            });
            return filters;
        }
        get rows() {
            return ClientModule.clients;
        }
        mounted() {
            this.assignColumnFilters();
        }
        created() {
            this.initialize();
            // Risk level names for the client-name tooltip
            ClientModule.GetRiskLevels();
        }
    };
    ClientsListing = __decorate([
        Component({
            name: "ClientsListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                SectionLoader,
                EcGrid,
                DeleteComponent,
                Switches,
            },
        })
    ], ClientsListing);
    return ClientsListing;
})();
export default ClientsListing;
